import type { Break } from 'snap-redux/infra/http/routesConfig/scopes/planning/types'

/**
 * Filter the shift breaks that contains a time-slot
 */
export const filterShiftBreaksWithSlot = (breaks: Break[]) => {
  return breaks.filter(item => Boolean(item.real_starts_at))
}
